export default __webpack_public_path__ + "static/media/TaxesAndRedevances.0396099e.PNG";